(function () {
  function parseCents(value) {
    const n = parseInt(String(value), 10);
    return Number.isFinite(n) ? n : 0;
  }

  function moneyStringToCents(str) {
    if (!str) return 0;
    const normalized = String(str).replace(/\s/g, '').replace(/[^\d.,]/g, '');
    const lastComma = normalized.lastIndexOf(',');
    const lastDot = normalized.lastIndexOf('.');
    let numeric = normalized;
    if (lastComma > lastDot) {
      numeric = normalized.replace(/\./g, '').replace(',', '.');
    } else {
      numeric = normalized.replace(/,/g, '');
    }
    const amount = parseFloat(numeric);
    return Number.isFinite(amount) ? Math.round(amount * 100) : 0;
  }

  function formatMoneyFromCents(cents, sampleMoneyString) {
    const sample = sampleMoneyString || '';
    const symbolMatch = sample.match(/^[^\d\s-]+/);
    const symbol = symbolMatch ? symbolMatch[0] : '£';
    const amount = (cents / 100).toFixed(2);
    if (sample.includes(',')) {
      return `${symbol}${amount.replace('.', ',')}`;
    }
    return `${symbol}${amount}`;
  }

  function getProductInfoForSpan(span) {
    return span?.closest('product-info') || document.querySelector('product-info');
  }

  function getAccessoryTotals(productInfo) {
    let price = 0;
    let compare = 0;
    const root = productInfo || document;

    root.querySelectorAll('input[data-accessories]:checked').forEach((input) => {
      price += parseCents(input.dataset.accessoryPriceCents);
      compare += parseCents(input.dataset.accessoryCompareCents);
    });

    return { price, compare };
  }

  function updateBaseFromCheckedVariant(span, productInfo) {
    const radio =
      productInfo?.querySelector('[data-select-kit] .nw-select-kit__input:checked') ||
      productInfo?.querySelector('.nw-pdp-variants__input:checked');
    if (!radio) return;

    const priceCents = radio.dataset.optionPriceCents;
    const compareCents = radio.dataset.optionComparePriceCents;

    if (priceCents) {
      span.dataset.basePriceCents = priceCents;
    }
    if (compareCents != null) {
      span.dataset.baseCompareCents = compareCents;
    }
  }

  function updateBaseFromVariantObject(span, variant) {
    if (!variant || typeof variant.price !== 'number') return;
    span.dataset.basePriceCents = String(variant.price);
    const compare =
      variant.compare_at_price && variant.compare_at_price > variant.price ? variant.compare_at_price : 0;
    span.dataset.baseCompareCents = String(compare);
  }

  function syncAtcSpan(span) {
    if (!span) return;

    const isPdpNew = span.classList.contains('nw-pdp-atc__inner');
    const sumAccessories = span.dataset.sumAccessoryPrices === 'true';
    if (!isPdpNew && !sumAccessories) return;
    if (span.__nwPdpAtcSyncing) return;

    span.__nwPdpAtcSyncing = true;

    try {
      const productInfo = getProductInfoForSpan(span);
      const priceEl = span.querySelector('[data-nw-pdp-atc-price]');
      const compareEl = span.querySelector('[data-nw-pdp-atc-compare]');
      const dividerEl = span.querySelector('.nw-pdp-atc__divider');
      const hideCompare = span.dataset.hideAtcCompare === 'true';
      const currencySample = span.dataset.currencySample || span.getAttribute('data-price') || '';

      if (isPdpNew) {
        updateBaseFromCheckedVariant(span, productInfo);
      }

      let priceCents = parseCents(span.dataset.basePriceCents);
      let compareCents = parseCents(span.dataset.baseCompareCents);

      if (sumAccessories) {
        const acc = getAccessoryTotals(productInfo);
        priceCents += acc.price;
        compareCents += acc.compare;
      }

      const price =
        priceCents > 0 ? formatMoneyFromCents(priceCents, currencySample) : span.getAttribute('data-price') || '';
      let compare = '';
      if (!hideCompare && compareCents > priceCents) {
        compare = formatMoneyFromCents(compareCents, currencySample);
      }

      if (span.getAttribute('data-price') !== price) {
        span.setAttribute('data-price', price);
      }

      const currentCompare = span.getAttribute('data-sale-price') || '';
      if (compare) {
        if (currentCompare !== compare) {
          span.setAttribute('data-sale-price', compare);
        }
      } else if (span.hasAttribute('data-sale-price')) {
        span.removeAttribute('data-sale-price');
      }

      if (priceEl && priceEl.textContent !== price) {
        priceEl.textContent = price;
      }

      if (compareEl) {
        if (compare && compare !== price) {
          if (compareEl.textContent !== compare) compareEl.textContent = compare;
          compareEl.hidden = false;
        } else {
          compareEl.textContent = '';
          compareEl.hidden = true;
        }
      }

      if (dividerEl) {
        dividerEl.hidden = !price;
      }
    } finally {
      span.__nwPdpAtcSyncing = false;
    }
  }

  function syncAllAtcButtons(root) {
    const scope = root || document;
    scope.querySelectorAll('.nw-pdp-atc__inner, span[data-sum-accessory-prices="true"]').forEach(syncAtcSpan);
  }

  function bindAccessoryListeners() {
    document.querySelectorAll('product-info').forEach((productInfo) => {
      if (productInfo.__nwAccessoryAtcBound) return;
      productInfo.__nwAccessoryAtcBound = true;

      productInfo.addEventListener('change', (event) => {
        if (event.target.matches('input[data-accessories], .nw-pdp-variants__input, .nw-select-kit__input')) {
          requestAnimationFrame(() => syncAllAtcButtons(productInfo));
        }
      });
    });
  }

  function scheduleSync() {
    requestAnimationFrame(() => syncAllAtcButtons());
  }

  function refreshBaseFromDisplayedPrice() {
    document.querySelectorAll('span[data-sum-accessory-prices="true"]').forEach((span) => {
      const priceStr = span.getAttribute('data-price');
      if (priceStr) {
        span.dataset.basePriceCents = String(moneyStringToCents(priceStr));
      }
      const compareStr = span.getAttribute('data-sale-price');
      span.dataset.baseCompareCents = compareStr ? String(moneyStringToCents(compareStr)) : '0';
    });
  }

  function onVariantChange(payload) {
    const variant = payload?.data?.variant;
    if (variant) {
      document.querySelectorAll('.nw-pdp-atc__inner, span[data-sum-accessory-prices="true"]').forEach((span) => {
        updateBaseFromVariantObject(span, variant);
      });
    }
    scheduleSync();
  }

  window.nwSyncAtcAfterButtonPriceUpdate = function () {
    refreshBaseFromDisplayedPrice();
    scheduleSync();
  };

  document.addEventListener('DOMContentLoaded', () => {
    bindAccessoryListeners();
    scheduleSync();
  });

  document.addEventListener('variant-selected', scheduleSync);

  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.variantChange, onVariantChange);
    subscribe(PUB_SUB_EVENTS.optionValueSelectionChange, scheduleSync);
  }
})();
